var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-embed',{attrs:{"type":"object","aspect":_vm.aspect}},[_c('div',{ref:"map",staticClass:"w-100 h-100"})])
}
var staticRenderFns = []

export { render, staticRenderFns }